import { sanitizeHtml, purifyHtml } from '@/helpers/html'

export const createParamsFromJson = (data: object | null = null, sanitizeAll: boolean = true): URLSearchParams => {
  const params = new URLSearchParams()

  if (data) {
    const stringData = JSON.stringify(data)
    const sanitizeData = sanitizeAll ? sanitizeHtml(stringData) : purifyHtml(stringData)
    params.append('json', sanitizeData)
  }

  return params
}

export const createJsonRequest = (data: object, sanitizeAll: boolean = true) => {
  const stringData = JSON.stringify(data)
  return sanitizeAll ? sanitizeHtml(stringData) : purifyHtml(stringData)
}
